import { SalesforceListTypes, SalesforceNamespace } from 'datasource-service-lib';
import { IWorkflowService } from 'interfaces-lib';
import { IPreMergeChecker } from '../../interfaces/ipremergechecker';
import { IMergeBasketViewConfig } from '../../merge-basket-view/merge-basket-view.component';
import { ServiceProviderService } from '../service.provider.service';
import { SalesforceFileToPathConverter } from './salesforce.filetopathconverter';
import { SalesforcePreMergeCheck } from './salesforce.premergecheck';
import { SharedServiceProviderServiceFactory } from 'shared-service-provider-lib';

// @TODO: work on premerge checks for salesforce
export class SalesforceMergeBasketViewConfig implements IMergeBasketViewConfig {
  readonly namespace = SalesforceNamespace.name;
  readonly workflowService: IWorkflowService;
  readonly entityType = undefined;
  readonly fileType = undefined;
  readonly fileToPathConverter = new SalesforceFileToPathConverter(SalesforceListTypes.FileAttachments);
  readonly preMergeChecker: IPreMergeChecker;

  constructor(serviceProviderService: ServiceProviderService, sharedServiceProvider: SharedServiceProviderServiceFactory) {
    this.workflowService = serviceProviderService.getWorkflowService(SalesforceNamespace.name);
    this.preMergeChecker = new SalesforcePreMergeCheck(serviceProviderService, sharedServiceProvider);
  }
}
